module.exports = __webpack_public_path__ + "flyer_background_snowy_branches_048-48671c1da29faff555c5ddd399d8a3ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_snowy_branches_048.jpg
// module id = 1688
// module chunks = 1